// src/lib/reportError.js
// Posts client-side errors to /api/report-client-error so the system monitor
// can diagnose and auto-fix the underlying code bug.
// Never throws — error reporting must never crash the app further.

export async function reportClientError({
  error_message,
  error_stack,
  component_stack,
  error_type = 'unknown',
  page_url,
}) {
  try {
    await fetch('/api/report-client-error', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        error_message: (error_message || 'Unknown error').slice(0, 500),
        error_stack:   (error_stack || '').slice(0, 2000),
        component_stack: (component_stack || '').slice(0, 1000),
        error_type,
        page_url:      (page_url || window.location.href).slice(0, 300),
        user_agent:    navigator.userAgent.slice(0, 200),
      }),
    })
  } catch {
    // Silently swallow — never let error reporting cause further problems
  }
}
